import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-timer-dial',
  templateUrl: './timer-dial.component.html',
  styleUrls: ['./timer-dial.component.scss'],
  animations: [
    trigger('line', [
      transition('off => on', [
        animate('{{duration}}s linear', keyframes([
          style({transform: 'rotate({{startAngle}}deg)', offset: 0}),
          style({transform: 'rotate(360deg)', offset: 1}),
        ]))
      ])
    ]),
    trigger('maskLeft', [
      state('off', style({visibility: 'visible'})),
      state('done', style({visibility: 'hidden'})),
      transition('off => on', [
        animate('{{duration}}s {{delay}}s', keyframes([
          style({visibility: 'hidden', offset: 0}),
          style({visibility: 'hidden', offset: 1})]))
      ])
    ]),
    trigger('maskRight', [
      state('off', style({visibility: 'hidden'})),
      state('done', style({visibility: 'visible'})),
      transition('off => on', [
        animate('{{duration}}s {{delay}}s', keyframes([
          style({visibility: 'visible', offset: 0}),
          style({visibility: 'visible', offset: 1})]))
      ])
    ])

  ]
})
export class TimerDialComponent implements OnInit {
  @Input() set timerTrigger(value) {
    if (value) {
      this.timerStart();
    }
  }

  @Input() secTotal = 0;
  @Input() secLeft = 0;

  startAngle = 0;
  duration = 0;
  delay = 0;

  timerState = 'off'; // off, start, done

  constructor() {
  }

  ngOnInit() {
  }

  timerStart() {
    this.initParams();
    this.timerState = 'off';
    setTimeout(() => {
      this.timerState = 'on';
    });
  }

  initParams() {
    this.startAngle = 360 - (360 * this.secLeft / this.secTotal);
    this.duration = this.secLeft;
    this.delay = this.secTotal / 2 + this.duration - this.secTotal > 0 ? this.secTotal / 2 + this.duration - this.secTotal : 0;
  }

  timerDoneEvent(e) {
    if (e.fromState === 'on' && e.toState === 'done') {
      this.timerState = 'done';
    }
  }
}
